var map = {
	"./dontknow.png": "d4de",
	"./eyesup.png": "8811",
	"./me1.png": "bc3b",
	"./relaxed.png": "3d2c",
	"./righthand.png": "bce9",
	"./secret.png": "edb8",
	"./serious.png": "a797",
	"./shock.png": "f0e2",
	"./sweat.png": "fc1a",
	"./thanks.png": "c7fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "66c5";